export const getGradle = (grade: string, gradeIa: string): string => {
  const gradeOrder = ['A', 'B', 'C', 'D']

  const finalGrade = gradeOrder.indexOf(gradeIa) > gradeOrder.indexOf(grade)
    ? gradeIa
    : grade
  return finalGrade
}
